<template>
    <gljy-dialog v-model="open" width="100%" :draggable="false"
    style="background: none !important;position: relative;"
    headerClass="headerClass" bodyClass="bodyClass" footerClass="footerClass" fullscreen append-to-body>
        <template #title>
            <div></div>
        </template>
        <template #header>
            <div></div>
        </template>
        <template v-for="url in previewUrlList" :key="url">
            <imgPreview ref="imgPreviewRef" v-show="url == currentShowUrl" :imageUrl="getUrl(url)"></imgPreview>
        </template>
        <div class="left-up switch-button" @click="switchImage(-1)">
            <el-icon><ArrowLeftBold /></el-icon>
        </div>
        <div class="right-next switch-button" @click="switchImage(1)">
            <el-icon><ArrowRightBold /></el-icon>
        </div>
        <div class="rotate" @click="onRotate">
            <el-icon><RefreshRight /></el-icon>
            </div>
    </gljy-dialog>
</template>

<script>
import { getToken } from '@/utils/auth'
import { reactive, ref, toRefs, computed } from 'vue';
import imgPreview from "./img-preview.vue";
export default {
    name: "gljy-img-preview",
    components: {
        imgPreview
    },
    props: {
        previewUrlList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    setup(props, context) {
        const imgPreviewRef = ref();
        const datas = reactive({
            open: false,
            currentShowUrl: ""
        })

        const currentImgIndex = computed(() => {
            return props.previewUrlList.findIndex(url => url === datas.currentShowUrl);
        })

        const token = getToken();

        const methods = {
            onClose() {
                datas.open = false;
            },
            init(url) {
                datas.currentShowUrl = url;

                console.log("datas.currentShowUrl", datas.currentShowUrl, props.previewUrlList)
                datas.open = true;
            },
            getUrl(url) {
                if (url.indexOf("Authorization") >= 0) {
                    return url;
                }
                return `${url}?Authorization=${token}`;
            },
            switchImage(addIndex) {
                if (addIndex > 0) {
                    if (currentImgIndex.value == props.previewUrlList.length - 1) {
                        datas.currentShowUrl = props.previewUrlList[0];
                        return;
                    }
                } else {
                    if (currentImgIndex.value == 0) {
                        datas.currentShowUrl = props.previewUrlList[props.previewUrlList.length - 1];
                        return;
                    }
                }
                datas.currentShowUrl = props.previewUrlList[currentImgIndex.value + addIndex];
                console.log("datas.currentShowUrl", datas.currentShowUrl)
            },
            onRotate(){
                imgPreviewRef.value.onRotate();
            }
        }

        return {
            ...toRefs(datas),
            ...methods,
            imgPreviewRef
        }
    }
}
</script>

<style lang="less">
.headerClass{
    padding: 0px !important;
    margin-right: 0px !important;
}
.bodyClass {
    overflow: hidden;
}
.footerClass{
    padding: 0px !important;
    margin-top: 0px !important;
}

.showImg {
    margin: auto;
}

.close {
    position: fixed;
    right: 1rem;
    top: 1rem;
    color: #ffffff;
    z-index: 2000;
}

.switch-button {
    position: fixed;
    top: 50%;
    cursor: pointer;
    background-color: #ffffff;
    opacity: 0.8;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
}

.switch-button:hover {
    border: 1px solid rgba(0, 0, 0, 0.5);
}

.left-up {
    left: 3rem;
}

.right-next {
    right: 3rem;
}

.rotate {
  position:fixed;
  bottom: 3rem;
  left: 50%;
  background-color: #ffffff;
  opacity: 0.8;
  padding: 0.5rem;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>